{
  "summary": "Resumen general",
  "linkToArticle": "Enlace al artículo",
  "title": "Título",
  "remove": "Eliminar",
  "imageOptional": "Imagen (opcional)",
  "articleConfiguration": "Configuración del artículo",
  "status": "Estado",
  "articleLink": "Enlace del artículo",
  "lastUpdated": "Última actualización",
  "uploadedBy": "Subido por",
  "articleName": "Nombre del artículo",
  "filter": "Filtro",
  "state": "Estado",
  "clearFilter": "Borrar filtro",
  "applyFilter": "Aplicar filtro",
  "active": "Activo",
  "inactive": "Inactivo",
  "draft": "Borrador",
  "paginatedView": "Visualizando 1 - 3 de {{totalCount}}",
  "errorStateMessage": "El campo no puede dejarse vacío",
  "errorUrlStateMessage": "El campo debe ser una URL válida",
  "cancel": "Cancelar",
  "confirm": "Confirmar",
  "deleteArticle": "Eliminar noticia",
  "deleteArticleMessage": "¿Confirma que desea eliminar esta noticia? Si lo hace, el contenido se borrará de forma permanente y no podrá recuperarlo.",
  "visibleToRoles": "Visible para roles",
  "visibleToRolesHelp": "Solo los usuarios con estos roles ven este artículo. Déjelo vacío para mostrarlo a todos los roles.",
  "visibleToRolesRemoveOnlyHelp": "La segmentación por roles está desactivada para esta organización. Puede eliminar roles, pero no agregarlos.",
  "visibleTo": "Visible para",
  "allRoles": "Todos los roles",
  "roleCount_one": "{{count}} rol",
  "showingAllRoles": "La vista previa incluye artículos para cada rol",
  "roleCount_other": "{{count}} roles"
}
